var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "18.248pt",
    height: "17.901pt",
    viewBox: "903.184 -720.382 18.248 17.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Imported Layer 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "scale(1 -1)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinejoin: "miter",
    stroke: "#323232",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 903.301,714.216 L 920.532,714.216",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 903.301,708.411 L 920.532,708.411",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 903.301,702.931 L 920.532,702.931",
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -2.875,
    y: -8.674,
    width: 5.751,
    height: 17.348,
    rx: 0,
    ry: 0,
    transform: "translate(912.308 717.057) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 903.674,714.654 L 903.674,702.743",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 920.982,714.654 L 920.982,702.743",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 909.443,714.408 L 909.443,702.744",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 915.212,714.408 L 915.212,702.744",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSmallIcon);
export default __webpack_public_path__ + "static/media/table-small-icon.d15fd3159d923af2c435340a89feab07.svg";
export { ForwardRef as ReactComponent };